import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { parse } from '../../util/urlHelpers';
import config from '../../config';

const CONSOLE_PAGE_SIZE = 100;

// ================ Async Thunks ================ //

export const fetchServiceFee = createAsyncThunk(
  'ConsoleServiceFeePage/fetchServiceFee',
  async (search, { dispatch, extra: sdk, rejectWithValue }) => {
    const {
      page = 1,
      userId,
      processState,
      countryId = config.custom.countryId,
      phrase,
      sort,
    } = parse(search);

    const paginationParams = {
      page,
      per_page: CONSOLE_PAGE_SIZE,
    };

    const queryParams = {
      serviceFee: true,
      ...paginationParams,
      include: ['provider', 'user'],
      userId,
      processState,
      countryId: countryId === 'all' ? undefined : countryId,
      phrase,
      sort,
    };

    try {
      const response = await sdk.newSdk.transactions.query(queryParams);
      dispatch(addMarketplaceEntities(response));
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const loadData = (params, search) => dispatch => {
  return dispatch(fetchServiceFee(search));
};

// ================ Slice ================ //

const initialState = {
  fetchInProgress: false,
  fetchServiceFeeError: null,
  pagination: null,
  serviceFee: [],
};

const consoleServiceFeePageSlice = createSlice({
  name: 'ConsoleServiceFeePage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchServiceFee.pending, state => {
        state.fetchInProgress = true;
        state.fetchServiceFeeError = null;
      })
      .addCase(fetchServiceFee.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.serviceFee = action.payload.data;
        state.pagination = action.payload.meta;
        state.fetchServiceFeeError = null;
      })
      .addCase(fetchServiceFee.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.serviceFee = [];
        state.pagination = null;
        state.fetchServiceFeeError = action.payload;
      });
  },
});

export default consoleServiceFeePageSlice.reducer;
